<section>
<h1 class="wa-heading-xl">Datenschutzerklärung / Privacy Statement</h1>
<p>
  Für die Technische Universität München ist Datenschutz ein wichtiges Anliegen.
  Wir möchten, dass Sie wissen, wann wir welche Daten speichern und wie wir sie verwenden.
  Personenbezogene Daten werden auf diesem Web-Server nur im notwendigen Umfang erhoben.
  Die Datenverarbeitung unterliegt den geltenden datenschutzrechtlichen Bestimmungen, insbesondere der
  Datenschutz-Grundverordnung (DSGVO), dem Bayerischen Datenschutzgesetz (BayDSG) und dem Telemediengesetz (TMG).
  Nachfolgend informieren wir Sie über Art, Umfang und Zweck der Erhebung und Verwendung personenbezogener Daten.
  Diese Informationen können jederzeit von unserer Webseite abgerufen werden.
</p>
<p>
  Data protection is an important concern for the Technical University of Munich.
  We would like you to know when which data is stored and how we use it.
  Personal data is only recorded to the extent necessary.
  Data processing is subject to the applicable data protection regulations, in particular the General Data Protection
  Regulation GDPR (Datenschutz-Grundverordnung DSGVO), the Bavarian Data Protection Act (BayDSG) and the Telemedia Act
  (TMG).
  This data protection declaration refers to the processing of personal data within the scope of this website (duty to
  provide information according to Art. 13, 14 of the GDPR (DSGVO)).
  In the following, we inform you about the type, scope and purpose of the collection and use of personal data.
  This information can be retrieved from our website at any time.
</p>
  </section>
<section>
  <h2 class="wa-heading-l">Verantwortlich für diese Webseite / Responsible authority</h2>
  Technische Universität München<br/>
  Arcisstraße 21<br/>
  80333 München<br/>
  Telefon/Phone: +4989289-01<br/>
  <a href="mailto:poststelle@tum.de">poststelle&#64;tum.de</a>
</section>

<section>
  <h2 class="wa-heading-l">Behördlicher Datenschutzbeauftragter der Technischen Universität München /
    Responsible Data Protection Officer of the Technical University of Munich:</h2>
  <dl class="wa-stack wa-gap-2xl">
    <div class="wa-flank" style="--flank-size: 20ch;">
      <dt>Website</dt>
      <dd><a href="https://www.datenschutz.tum.de">https://www.datenschutz.tum.de</a></dd>
    </div>
    <div class="wa-flank" style="--flank-size: 20ch;">
      <dt>Email</dt>
      <dd><a href="mailto:beauftragter@datenschutz.tum.de">beauftragter&#64;datenschutz.tum.de</a></dd>
    </div>
  </dl>
</section>

<section>
  <h2 class="wa-heading-l">Zweck der Datenverarbeitung und gesetzliche Grundlage</h2>
  <p>
    Zweck der Verarbeitung personenbezogener Daten ist der Betrieb dieser Website, insbesondere die
    Implementierung eines Zuteilungssystems („Prüfungszuteilung“) für die Zuteilung von Prüfungsaufsichten und
    Prüfungskorrektoren und -korrektorinnen für die Prüfungen des Department of Mathematics der TUM School of
    Computation, Information and Technology.
    Das Prüfungszuteilungssystem ist ein Werkzeug, das den Verantwortlichen hilft, die Mitarbeiter und
    Mitarbeiterinnen für die Prüfungsaufsicht und -korrektur entsprechend ihrer jeweiligen Aufgaben
    einzuteilen.
    Die Mitarbeiterinnen und Mitarbeiter können ihre Präferenzen bezüglich Verfügbarkeit, Ort und Sprache
    innerhalb eines bestimmten Zeitraums im System eingeben.
    Das System verwendet diese Informationen zusammen mit Daten, die es von der Verwaltung erhält
    (insbesondere Beginn und Ende des Arbeitsvertrags soweit das Datum im jeweiligen Prüfungszeitraum liegt,
    Umfang der Aufsichts- bzw. Korrekturverpflichtung und Beteiligung am Unterrichtsbetrieb im laufenden
    Semester), um einen Vorschlag für die Zuteilung von Mitarbeiterinnen und Mitarbeitern zu
    Prüfungsaufsichten und -korrekturen zu berechnen, der möglichst viele Präferenzen berücksichtigt.
    Das Verfahren dient damit dem Zweck der Personalverwaltung nach Art. 6 Abs. 1 lit. e DSGVO
    in Verbindung mit Art. 4 Abs. 1 BayDSG und Art. 10 Abs. 3 BayHIG.

  </p>
  <p>
    Personenbezogene Daten (IP-Adresse) werden nur insoweit erhoben, als dies für den Betrieb und die
    Sicherheit dieser Website erforderlich ist.
    Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten ist Art. 6 Abs. 1 lit. e DSGVO
    in Verbindung mit Art. 4 Abs. 1 BayDSG und Art. 10 Abs. 3 BayHIG.
    Gegebenenfalls werden Ihre Daten im Rahmen gesetzlicher Bestimmungen an die zuständigen Aufsichts- und
    Prüfungsbehörden übermittelt, um ihnen die Wahrnehmung ihrer Kontrollrechte zu ermöglichen.
    Zur Abwehr von Gefahren für die Sicherheit in der Informationstechnik können elektronisch übermittelte
    Daten an das Landesamt für Sicherheit in der Informationstechnik zur Verarbeitung auf der Grundlage der
    Art. 12 ff. des Bayerischen E-Government-Gesetzes weitergegeben werden.
  </p>
</section>

<section>
  <h2 class="wa-heading-l">Purpose and legal basis for data processing</h2>
  <p>
    The purpose of processing personal data is to operate this website, in particular to implement an
    allocation system ('exam allocation') for allocating exam supervisors and exam correctors, to the
    examinations of the department of mathematics at TUM School of Computation, Information and Technology.
    The exam allocation system provides a tool to help the responsible persons allocate staff for exam
    supervision and exam correction according to their respective duties.
    As soon as an instance has been created, staff members may enter their preferences regarding availability,
    place, and language within a certain period of time.
    The system uses this information together with data obtained from the school's administrative offices (in
    particular, start and end dates of work contract, supervision / correction workload and participation in
    the ongoing semester's classes) to calculate a suggested allocation of staff members to exams respecting
    as many perferences as possible.
    The procedure thus serves the purpose of staff administration according to art. 6 par. 1 lit. e DSGVO
    together with art. 4 par. 1 BayDSG and art. 10 par. 3 BayHIG.
  </p>
  <p>
    Personal data (IP address) is only retrieved if it is necessary for the purpose of operating and securing
    this website.
    The legal basis for the processing of personal data is art. 6 par. 1 lit. e DSGVO
    together with art. 4 par. 1 BayDSG and art. 10 par. 3 BayHIG.
    If necessary, your data may be transmitted to the responsible supervisory and auditing authorities to
    exercise the respective rights of control.
    To prevent danger to security in information technology, electronically transmitted data may be forwarded
    to the State Office for Information Security to be processed on the basis of Art. 12 ff. of the Bavarian
    E-Government Act.
  </p>
</section>

<section>
  <h2 class="wa-heading-l">Nutzung personenbezogener Daten</h2>
  <p>
    Abgesehen von einigen statischen Teilen, die kein Login erfordern, sind die meisten Teile dieser Website
    nur zugänglich, wenn Sie mit einem TUM-Account eingeloggt sind.
    Personenbezogene Daten, die Sie über die Formulare auf dieser Website übermitteln können, dienen nur dem
    in den Formularen angegebenen Zweck.
    Bitte beachten Sie die entsprechenden Hinweise auf diesen Formularen.
  </p>
  <p>
    Personenbezogene Daten werden in der Regel in einer von der TUM School of Computation, Information and
    Technology gehosteten Datenbank gespeichert und sind den für die Einteilung von Aufsichten und
    Korrektorinnen bzw. Korrektoren zuständigen TUM-Mitarbeitern zugänglich.
    Darüber hinaus sind die Daten auch dem Personal zugänglich, das für die technische Administration dieser
    Website zuständig ist.
    Wenn der Zweck der Datenerhebung darin besteht, die Daten anderen Mitgliedern der TUM zugänglich zu
    machen, wird der Grundsatz der Datenminimierung beachtet.
    Ihre Daten werden nicht an Dritte weitergegeben, es sei denn, dies ist im Formular ausdrücklich vermerkt.

    Die Nutzer (Mitarbeiterinnen und Mitarbeiter mit Aufsichts-/Korrekturpflichten, Prüfungsbeauftragte,
    Prüfende und Personen, die mit der Organisation von Prüfungen betraut sind) melden sich über Shibboleth am
    System an, die notwendigen Informationen werden dann in das System übertragen und dort gespeichert.
    Insbesondere speichert das System Nachname, Vorname, E-Mail-Adresse und eine eindeutige Kennung für jeden
    Nutzer.
    Zusätzlich werden Daten zu, Zeitpunkt des Beginns und Endes eines Vertrages (sofern eines davon im
    Zeitfenster der Prüfungsaufsicht/-korrektur liegt), das jeweilige Deputat für Aufsicht und Korrektur sowie
    die Teilnahme an den Lehrveranstaltungen des laufenden Semesters gespeichert.
    Darüber hinaus speichert das System alle auf freiwilliger Basis über Formulare übermittelten Daten, die
    später für die Zuteilung verwendet werden.
    Dazu gehören insbesondere Daten über Sprachpräferenzen, Ortspräferenzen und zeitlichen Verfügbarkeiten,
    die von den Mitarbeiterinnen und Mitarbeitern auf freiwilliger Basis angegeben werden.
  </p>
  <p>
    Der Login über Shibboleth ermöglicht es uns, das System ohne eine Speicherung von Passwörtern oder damit
    in Zusammenhang stehenden Daten zu betreiben.
    Die Vertraulichkeit, Integrität, Verfügbarkeit und Ausfallsicherheit des Systems ist daher von dem
    regelmäßig gewarteten, getesteten und überwachten TUM Single Sign-On System abhängig.
    Es werden nur die personenbezogenen Daten gespeichert, die für die Durchführung des Zwecks dieses Systems
    unbedingt erforderlich sind.
    Die Systeme werden regelmäßig aktualisiert
  </p>
  <p>
    Ihre Daten werden nur so lange gespeichert, wie es für die Erfüllung der Aufgaben unter Beachtung der
    gesetzlichen Aufbewahrungsfristen erforderlich ist.
    Nicht mehr benötigte Daten werden am Ende der jeweiligen Prüfungsphase gelöscht. Das betrifft auch alle
    Daten, die zur Berechnung der Zuteilung verwendet wurden sowie die Zuteilung selbst.
  </p>
</section>

<section>
  <h2 class="wa-heading-l">Usage and disclosure of personal data</h2>
  <p>
    Apart from some static parts that do not require a login most parts of this website are only accessible
    once logged in with a TUM account.
    Personal data provided via the forms on this website will only be accepted with your consent and will only
    serve the purpose stated in the forms.
    Please note the corresponding information on these forms.
    Personal data is usually stored in a database hosted by the TUM School of Computation, Information and
    Technology and is accessible to TUM employees responsible for staff allocation and IT administrative staff
    for this website.
    If the purpose of the data collection is to make the data accessible to other members of TUM, the
    principle of data minimization is followed.
    Your data will not be passed on to third parties, unless this is explicitly stated in the form.
    The users (staff members with supervision / correction duties, persons responsible for the allcation,
    examiners and exam organizers) log on to the exam allocation system via Shibboleth, the necessary
    information is then transferred and stored in the exam allocation system.
    In particular, the system stores last names, first names, email addresses, and a unique identifier for
    each user.
    Additionally, data on the start and end of a contract (if it lies in the exam supervision / correction
    time window), the workload for supervision and correction, and the participation in the ongoing semester's
    classes is stored.
    Moreover, the system stores all data submitted via forms that will subsequently be utilized for the exam
    duties allocation.
    This includes in particular data about language preferences, place preferences, and availability submitted
    by staff members on a voluntary basis.
  </p>
  <p>
    The registration process via Shibboleth allows us to operate the system without a dedicated user and
    password management system.
    Confidentiality, integrity, availability and resilience of the system is therefore dependent on the
    regularly maintained, tested and monitored TUM single sign-on system.
    Only the personal data that is absolutely necessary for the implementation of the purpose of this system
    (exam allocation) is stored.
    The systems are updated on a regular basis.
  </p>
  <p>
    Your data will only be stored as long as it is necessary for the fulfilment of the tasks in compliance
    with legal retention periods.
    Data that is no longer required will be deleted at the end of the respective examination phase, together
    with all data used for computing the allocation.
  </p>
</section>

<section>
  <h2 class="wa-heading-l">Ihre Rechte</h2>
  Soweit Ihre personenbezogenen Daten verarbeitet werden, stehen Ihnen als betroffener Person die folgenden
  Rechte zu:
  <ul>
    <li>Sie haben das Recht auf Auskunft über die zu Ihrer Person gespeicherten Daten (Art. 15 GDPR /
      DSGVO).
    </li>
    <li>SIe haben das Recht unkorrekte Daten zu Ihrer Person berichtigen zu lassen (Art. 16 GDPR / DSGVO).
    </li>
    <li>Bei Erfüllung der entsprechenden gesetzlichen Voraussetzungen können Sie die Löschung Ihrer Daten
      oder die Einschränkung ihrer Verarbeitung verlangen (Art. 17 und 18 GDPR / DSGVO).
    </li>
    <li>Wenn Sie in die Datenverarbeitung eingewilligt haben oder ein Vertrag über die Datenverarbeitung
      besteht und die Datenverarbeitung mit Hilfe automatisierter Verfahren erfolgt, können Sie ein Recht
      auf Datenübertragbarkeit haben (Art. 20 DSGVO).
    </li>
    <li>Wenn Sie in die Verarbeitung Ihrer Daten eingewilligt haben und die Verarbeitung auf dieser
      Einwilligung beruht, können Sie Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen.
      Dies berührt nicht die Rechtmäßigkeit der Datenverarbeitung aufgrund der Einwilligung vor deren
      Widerruf.
    </li>
  </ul>
  <p>
    Erfolgt die Verarbeitung Ihrer Daten ausschließlich auf der Grundlage von Art. 6 Abs. 1 Buchstabe e oder f
    DSGVO (Art. 21 Abs. 1 Satz 1 D DSGVO), dann haben Sie das Recht, aus Gründen, die sich aus Ihrer
    persönlichen Situation ergeben, jederzeit gegen die Verarbeitung Widerspruch einzulegen.
    Einschränkungen und Modifikationen der vorgenannten Rechte können sich aus Art. 9 und 10 BayDSG und Art.
    20 BayDSG ergeben.
    Wenn Sie uns Ihre Einwilligung erteilt haben, können Sie diese jederzeit mit Wirkung für die Zukunft
    widerrufen.
    Um Ihre Rechte auf Auskunft, Berichtigung oder Löschung wahrzunehmen oder eine erteilte Einwilligung zu
    widerrufen, wenden Sie sich bitte an die folgende Adresse:
  </p>
  TUM School of Computation, Information and Technology<br/>
  Arcisstr. 21<br/>
  80333 München<br/>
  Email: <a href="mailto:exam.allocation@math.cit.tum.de">exam.allocation&#64;math.cit.tum.de</a>
</section>
<section>
  <h2 class="wa-heading-l">Your rights</h2>
  As far as your personal data are processed, you, as the data subject, are entitled to the following
  rights:
  <ul>
    <li>You have the right to be informed about the data stored about you (Art. 15 GDPR / DSGVO).</li>
    <li>If incorrect personal data is processed, you have the right to have it corrected (Art. 16 GDPR /
      DSGVO).
    </li>
    <li>If the legal requirements are met, you can demand the deletion of your data or the restriction of
      its processing (Art. 17 and 18 GDPR / DSGVO).
    </li>
    <li>If you have consented to the data processing or if a contract for data processing exists and the
      data processing is carried out using automated procedures, you may have the right to transfer the data
      (Art. 20 GDPR / DSGVO).
    </li>
    <li>If you have consented to the processing of your data and the processing is based on this consent,
      you can revoke your authorization at any time in the future. This does not affect the legality of data
      processing based on consent before its withdrawal.
    </li>
  </ul>

  <p>
    If processing of your data is executed solely on the basis of Art. 6 Par. 1 Letter e or f GDPR / DSGVO
    (Art. 21 Par. 1 Sentence 1 D GDPR / DSGVO), you have the right to object the processing at any time for
    reasons based on your personal situation.
    Restrictions and modifications of the aforementioned rights may result from Art. 9 and 10 BayDSG and Art.
    20 BayDSG.
    If you have given us your consent, you can revoke it at any time in the future.
    To exercise your rights to information, correction or deletion or to revoke a previously granted consent,
    please contact us at the following address:
  </p>
  TUM School of Computation, Information and Technology<br/>
  Arcisstr. 21<br/>
  80333 München<br/>
  Email: <a href="mailto:exam.allocation@math.cit.tum.de">exam.allocation&#64;math.cit.tum.de</a>
</section>
<section>
  <h2 class="wa-heading-l">Beschwerderecht bei der Aufsichtsbehörde</h2>
  <p>
    Sie können jederzeit eine Beschwerde beim Bayerischen Landesbeauftragten für den Datenschutz einreichen.
    Bitte nutzen Sie die folgenden Kontaktinformationen:
  </p>
  <p>
    <span class="wa-heading-m">Postanschrift:</span>
    Postfach 22 12 19, 80502 München
  </p>

  <p>
    <span class="wa-heading-m">Adresse:</span>
    Wagmüllerstraße 18, 80538 München
  </p>
  <p>
    <span class="wa-heading-m">Telefon:</span>
    +49 (0) 89 212672 0
  </p>
  <p>
    <span class="wa-heading-m">Fax:</span>
    +49 (0) 89 212672 50
  </p>
  <p>
    <span class="wa-heading-m">E-Mail:</span>
    <a href="mailto:poststelle@datenschutz-bayern.de">poststelle&#64;datenschutz-bayern.de</a>
  </p>
  <p>
    <span class="wa-heading-m">Website:</span>
    <a href="https://www.datenschutz-bayern.de">https://www.datenschutz-bayern.de</a>
  </p>
</section>

<section>
  <h2 class="wa-heading-l">Right of appeal to the supervisory authority</h2>
  <p>
    You may at any time file a complaint with the Bavarian State Commissioner for Data Protection.
    Please use the following contact information:
  </p>
  <p>
    <span class="wa-heading-m">postal address:</span>
    Postfach 22 12 19, 80502 München
  </p>
  <p>
    <span class="wa-heading-m">address:</span>
    Wagmüllerstraße 18, 80538 München
  </p>
  <p>
    <span class="wa-heading-m">phone:</span>
    +49 (0) 89 212672 0
  </p>
  <p>
    <span class="wa-heading-m">fax:</span>
    +49 (0) 89 212672 50
  </p>
  <p>
    <span class="wa-heading-m">email:</span>
    <a href="mailto:poststelle@datenschutz-bayern.de">poststelle&#64;datenschutz-bayern.de</a>
  </p>
  <p>
    <span class="wa-heading-m">website:</span>
    <a href="https://www.datenschutz-bayern.de">https://www.datenschutz-bayern.de</a>
  </p>
</section>

<section>
  <h2 class="wa-heading-l">Cookies und aktive Komponenten</h2>
  Wir verwenden aktive Komponenten wie Javascript.
  Diese Funktion kann über die Einstellungen Ihres Internetbrowsers ausgeschaltet werden, was die
  Funktionalität dieser Website beeinträchtigen kann.
  Wenn Sie auf diese Website zugreifen, speichern wir Cookies (kleine Dateien) auf Ihrem Gerät, die für
  die
  Dauer Ihres Besuchs auf der Website gültig sind („Session-Cookies“).
  Wir verwenden diese ausschließlich während Ihres Besuchs auf unserer Website.
  Die meisten Browser sind so eingestellt, dass sie die Verwendung von Cookies akzeptieren.
  Diese Funktion kann jedoch von Ihnen für die aktuelle Sitzung oder dauerhaft deaktiviert werden, indem
  Sie
  die Einstellungen Ihres Internetbrowsers anpassen.
  Nach Beendigung Ihres Besuchs wird Ihr Browser diese Cookies automatisch löschen.
</section>

<section>
  <h2 class="wa-heading-l">Cookies and active components</h2>
  We use active components like Javascript.
  This function can be switched off by adjusting your internet browser settings, which may impair the
  functionality of this website.
  When you access this website, we store cookies (small files) on your device that are valid for the
  duration of your visit to the website ('session cookies').
  We use these exclusively during your visit to our website.
  Most browsers are set to accept the use of cookies.
  This function can, however, be deactivated by you for the current session or permanently by adjusting
  your
  internet browser settings.
  At the end of your visit, your browser can automatically delete these cookies.
</section>

<section>

  <h2 class="wa-heading-l">Technische Umsetzung</h2>
  Wenn Sie auf diese Website zugreifen, übermitteln Sie über Ihren Internet-Browser Daten an unseren
  Webserver.
  Der Server wird von der TUM School of Computation, Information and Technology, Arcisstr. 21, 80333
  München, betrieben.
  Bei jedem Zugriff auf unsere Website speichern die Webserver temporär die folgenden Informationen in
  Logfiles:
  <ul>
    <li>IP-Adresse des anfragenden Computers,</li>
    <li>Datum und Uhrzeit des Zugriffs,</li>
    <li>Name, URL und Menge der übertragenen Daten für jede Datei,</li>
    <li>Zugriffsstatus (angefragte Daten, nicht gefundene Daten, blockierte Zugriffe, etc.),</li>
    <li>Identifikationsdaten des Internetbrowsers und des Betriebssystems (falls diese vom benutzten
      Browser
      übertragen werden),
    </li>
    <li>die Webseite, von der aus der Zugriff erfolgt ist (falls diese vom benutzten Browser übertragen
      wird).
    </li>
  </ul>
  Die Daten in den Logfiles werden wie folgt verarbeitet:
  <ol>
    <li>Die Log-Einträge werden fortlaufend automatisiert ausgewertet um Angriffe auf unsere Webserver zu
      entdecken und entsprechende Reaktionen einleiten zu können.
    </li>
    <li>In einigen Fälle, wie z.B. bei Fehlern und Sicherheitsvorfällen, werden die Einträge manuell
      analysiert.
    </li>
    <li>Log-Einträge, die älter als sieben Tage sind werden anonymisiert durch Kürzung der IP-Adresse und
      zur statistischen Auswertung genutzt. Die dafür erforderliche Software wird lokal am
      Leibniz-Rechenzentrum betrieben.
    </li>
    <li>The IP-Aadressen in den Logs werden nicht mit anderen Datenquellen am LRZ zusammengeführt. Ein
      Rückschluss auf bestimmte Personen ist somit nicht möglich.
    </li>
  </ol>
</section>

<section>
  <h2 class="wa-heading-l">Technical implementation</h2>
  When you access this or other websites, you transmit data to our web server via your internet browser.
  The server is operated by the TUM School of Computation, Information and Technology, Arcisstr. 21, 80333
  München.
  Whenever our website is accessed, the web servers temporarily store the following information in log
  files:
  <ul>
    <li>IP address of the requesting computer,</li>
    <li>Date and time of access,</li>
    <li>Name, URL and amount of data transferred for each retrieved file,</li>
    <li>Access status (requested files to be transferred, files not found etc.),</li>
    <li>Identification data of the browser and operating system used (if transmitted by the requesting web
      browser),
    </li>
    <li>Website from which the access was made (if transmitted by the requesting web browser).</li>
  </ul>
  The data in this log file is processed as follows:
  <ol>
    <li>The log entries are automatically and continuously evaluated in order to detect attacks on the web
      servers and to be able to react accordingly.
    </li>
    <li>In individual cases, i.e. in case of reported malfunctions, errors and security incidents, a
      manual
      analysis is performed.
    </li>
    <li>Log entries older than seven days are anonymized by shortening the IP address. The anonymized logs
      are used to generate access statistics. The software used for the anonymization process is operated
      locally by the LRZ.
    </li>
    <li>The IP addresses contained in the log entries are not merged with other databases of the LRZ, thus
      no conclusions can be drawn about individual persons.
    </li>
  </ol>
</section>

<section>
  <h2 class="wa-heading-l">Auswertung des Nutzerverhaltens / Web Tracking</h2>
  <p>
    Wir verwenden keinerlei Software um das Nutzerverhalten auf dieser Website auszuwerten.
  </p>
  <p>
    We do not use any programs to evaluate user behaviour.
  </p>
</section>

<section>
  <h2 class="wa-heading-l">Links</h2>
  <p>
    Von diesen eigenen Inhalten sind Querverweise („Links“) auf die von anderen Anbietern bereitgehaltenen
    Inhalte zu unterscheiden.
    Durch den Querverweis ermöglichen wir lediglich den Zugang zur Nutzung fremder Inhalte nach § 8
    Telemediengesetz (TMG).
    Bei der erstmaligen Verknüpfung mit diesen Internetangeboten haben wir den fremden Inhalt daraufhin
    überprüft, ob durch ihn eine mögliche zivilrechtliche oder strafrechtliche Verantwortlichkeit ausgelöst
    wird.
    Wir können diese fremden Inhalte jedoch nicht ständig auf Veränderungen überprüfen und deshalb auch
    keine
    Gewähr dafür übernehmen.
    Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung
    oder Nichtnutzung von Informationen Dritter entstehen, haftet allein der jeweilige Anbieter der Seite.
  </p>
  <p>
    Cross-references (links) to the websites of other providers must be distinguished from our own content.
    Through these links, we merely enable access to the use of third-party content in accordance with § 8
    Telemediengesetz / German Telemedia Act.
    When we first linked to these websites, we checked these third-party contents to see whether they might
    cause civil or criminal liability.
    However, we cannot constantly check this third-party content for changes and therefore cannot assume any
    liability for it.
    The respective provider of the site is solely liable for illegal, incorrect or incomplete content and in
    particular for damage resulting from the use or non-use of information from third parties.
  </p>
</section>

<section>
  <h2 class="wa-heading-l">E-Mail-Sicherheit / Email security</h2>
  <p>
    Unverschlüsselte Informationen, die per elektronischer Post (E-Mail) an uns gesendet werden, können
    unter
    Umständen während des Übertragungsvorgangs von Dritten gelesen werden.
    In der Regel können wir Ihre Identität nicht überprüfen und wissen nicht, wer sich hinter einer
    E-Mail-Adresse verbirgt.
    Eine rechtssichere Kommunikation per einfacher E-Mail ist daher nicht gewährleistet.
    Wie viele E-Mail-Anbieter setzen auch wir Filter gegen unerwünschte Werbung („SPAM-Filter“) ein, die in
    seltenen Fällen normale E-Mails fälschlicherweise als unerwünschte Werbung einstufen und löschen.
    In jedem Fall löschen wir automatisch E-Mails, die schädliche Programme (Viren / Malware) enthalten.
  </p>
  <p>
    Unencrypted information sent to us by electronic mail (email) can possibly be read by third parties
    during
    the transmission process.
    As a rule, we cannot verify your identity and do not know who is behind an email address.
    A legally secure communication by simple email is therefore not guaranteed.
    Like many email providers, we use filters against unwanted advertising ('SPAM filters'), which in rare
    cases erroneously classify normal emails as unwanted advertising and delete them.
    In any case, we automatically delete emails that contain damaging programs (viruses / malware).
  </p>
</section>
